// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "co.muza",
    name: "MUZA",
    homepage: "https://muza.co",
    image_id: "f8516ff9-ca2e-4b59-65f6-ed8ef438f100",
    app: {
        browser: null,
        ios: "https://apps.apple.com/th/app/muza-wallet-nft-web3/id6450735857",
        android: "https://play.google.com/store/apps/details?id=com.muza.muza&pcampaignid=web_share",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "muza://",
        universal: "https://muza.co/app",
    },
    desktop: {
        native: "muza://",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map